var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import dynamic from 'next/dynamic';
import { TrustYouReviewDialog } from '../TrustYouReview/TrustYouReviewDialog';
const TripAdvisorReviewsDialog = dynamic(() => import('../../tripadvisor/TripAdvisorReviewsDialog').then((module) => module.TripAdvisorReviewsDialog), { ssr: false });
const HotelCustomerReviewsDialog = dynamic(() => import('../HotelCustomerReviewsDialog/HotelCustomerReviewsDialog').then((module) => module.HotelCustomerReviewsDialog), { ssr: false });
export function HotelReviewsDialog(_a) {
    var { hotel, origin } = _a, other = __rest(_a, ["hotel", "origin"]);
    const { estabId, name, starRating, tripadvisorFeedback, customerFeedback, trustYouReviewClusterId } = hotel;
    if (origin === 'tripadvisor' && tripadvisorFeedback) {
        return (React.createElement(TripAdvisorReviewsDialog, Object.assign({ tripadvisorFeedback: tripadvisorFeedback, hotelName: name, estabId: estabId }, other)));
    }
    if (origin === 'trustyou' && trustYouReviewClusterId) {
        return React.createElement(TrustYouReviewDialog, Object.assign({ clusterId: trustYouReviewClusterId, hotelName: name }, other));
    }
    if (customerFeedback) {
        return (React.createElement(HotelCustomerReviewsDialog, Object.assign({ hotelName: name, estabId: estabId, starRating: starRating, customerFeedback: customerFeedback }, other)));
    }
    return null;
}
